import { Pipe, PipeTransform } from "@angular/core";

//sort.ts
@Pipe({ name: 'sort' })
export class SortPipe implements PipeTransform {
    transform(items: [], direction: string, column: string, type: string) {
        if (!direction) return items;
        let sortedItems = [];
        sortedItems = direction === "asc" ?
            this.sortAscending(items, column, type) :
            this.sortDescending(items, column, type)
        return sortedItems;
    }
    sortAscending(items: any[], column: string, type: any) {
        return [...items.sort((a: any, b: any) => {
            if (type === "string" && column === 'name') {
                if (a[column]?.toUpperCase() < b[column]?.toUpperCase()) return -1;
                else if (a[column]?.toUpperCase() > b[column]?.toUpperCase()) {
                    return 1;
                } else {
                    return 0;
                }
            }
            else if (column === 'number') {
                return a[column] - b[column];
            }
            else {
              const keyA = this.getSortKey(a);
              const keyB = this.getSortKey(b);

              return keyA.toString().localeCompare(keyB.toString());
            }
        })]
    }
    sortDescending(items: any[], column: string, type: any) {
        return [...items.sort((a: any, b: any) => {
            if (type === "string" && column === 'name') {
                if (a[column]?.toUpperCase() > b[column]?.toUpperCase()) return -1;
                else if (a[column]?.toUpperCase() < b[column]?.toUpperCase()) {
                    return 1;
                } else {
                    return 0;
                }
            }
            else if (column === 'number') {
                return b[column] - a[column];
            }
            else {

              const keyA = this.getSortKey(b);
              const keyB = this.getSortKey(a);

              return keyA.toString().localeCompare(keyB.toString());
            }
        })]
    }

  getSortKey(folder: any) {
    const lastCompletedAt = new Date(folder.latestCompletedAt).getTime();
    const createdAt = new Date(folder.createdAt).getTime();
    const defaultDate = new Date(1970, 0, 1).getTime();

    return lastCompletedAt !== defaultDate && lastCompletedAt > createdAt ? lastCompletedAt : createdAt;
  }
}
